import React from "react";
import { Box, Typography } from "@mui/material";
import { getFilterDisplayEntries } from "../InventoryComponents/filterDisplayUtils";
import { tokens } from "../../Common/designTokens";

// Match the bond detail boxes used in BondDetailsPanel / ActualOrderTab.
const boxStyle = {
  bgcolor: tokens.colors.defaultGridRowColor,
  borderRadius: "8px",
  border: `1px solid ${tokens.colors.bodyBorderColor50}`,
  px: 1,
  py: 0.5,
};

const labelStyle = {
  color: tokens.colors.fontColour85,
  mb: 0.1,
};

const valueStyle = {
  color: tokens.colors.fontColour,
};

/**
 * Renders characteristic filters as read-only detail boxes, matching the bond
 * detail boxes shown in ActualOrderTab / BondDetailsPanel. Used in place of
 * FilterChips when viewing a characteristic / ladder opened from the staging
 * "Source" column.
 */
const FilterDetailsBoxes = ({ input, emptyText = "No characteristics applied." }) => {
  const entries = getFilterDisplayEntries(input);

  if (!entries.length) {
    return (
      <Typography variant="body2" sx={{ color: tokens.colors.fontColour85 }}>
        {emptyText}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {entries.map(({ key, label, value }) => (
        <Box key={key} sx={boxStyle}>
          <Typography variant="caption" sx={labelStyle}>
            {label}
          </Typography>
          <Typography variant="body2" sx={valueStyle} title={String(value ?? "")}>
            {value === undefined || value === null || value === "" ? "---" : value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default FilterDetailsBoxes;
